import React from "react";
import LineChart from "@common/components/LineChart";
import { useChartState } from "../hooks/useChartState";
import { useDeviceChartData } from "./useDeviceChartData";
import { DeviceLiveChartProps } from "./types";

const DeviceLiveChart = (props: DeviceLiveChartProps) => {
  const {
    title,
    color,
    meetingAnnotations,
    device,
    customGraph,
    graphType,
    start,
    end,
  } = props;

  const deviceChartData = useDeviceChartData({
    device,
    graphType,
    customGraph,
    start,
    end,
  });

  const { chartData, yMax, unitMeasurement } = useChartState({
    chartData: deviceChartData,
    title,
    device,
    customGraph,
    graphType,
  });

  return (
    <LineChart
      title={title}
      color={color}
      chartData={chartData}
      unitMeasurement={unitMeasurement}
      annotations={meetingAnnotations}
      yMax={yMax}
      start={start}
      end={end}
    />
  );
};

export default DeviceLiveChart;
